import React, { useMemo } from "react";
import {
  FOLDER_LIBRARY_CATEGORIES,
  normalizeFolderCategory,
} from "./isfFolderLibraryService";
import MilestoneSingleOptionPicker from "./MilestoneSingleOptionPicker";

export const resolveFolderCategoryForName = (folderName, folderOptions = []) => {
  if (!folderName) return "eISF";
  const match = folderOptions.find(
    (opt) => opt.value === folderName || opt.label === folderName,
  );
  return normalizeFolderCategory(match?.folderCategory || "eISF");
};

const MilestoneFolderSelect = ({
  folderOptions = [],
  folderCategory = "eISF",
  selectedFolderName = "",
  readOnly = false,
  lockedCategory = null,
  error = "",
  required = false,
  onCategoryChange,
  onFolderChange,
  compact = false,
}) => {
  const activeCategory = normalizeFolderCategory(
    lockedCategory || folderCategory,
  );
  const categoryChoices = lockedCategory
    ? FOLDER_LIBRARY_CATEGORIES.filter(
        (cat) => cat.value === normalizeFolderCategory(lockedCategory),
      )
    : FOLDER_LIBRARY_CATEGORIES;

  const filteredFolderOptions = useMemo(
    () =>
      folderOptions
        .filter(
          (opt) =>
            normalizeFolderCategory(opt.folderCategory) === activeCategory,
        )
        .map((opt) => ({
          value: opt.value,
          label: opt.label || opt.value,
        })),
    [folderOptions, activeCategory],
  );

  return (
    <div
      className={[
        "milestone-folder-select",
        compact ? "milestone-folder-select--compact" : "",
      ]
        .filter(Boolean)
        .join(" ")}
    >
      <label className="milestone-modal-label milestone-modal-label--compact">
        Library
      </label>
      <div
        className="milestone-folder-select__toggle"
        role="group"
        aria-label="Folder library category"
      >
        {categoryChoices.map((cat) => {
          const isActive = activeCategory === cat.value;
          return (
            <button
              key={cat.value}
              type="button"
              className={`milestone-folder-select__toggle-btn${isActive ? " is-active" : ""}`}
              disabled={readOnly || Boolean(lockedCategory)}
              aria-pressed={isActive}
              onClick={() => onCategoryChange?.(cat.value)}
            >
              {cat.label}
            </button>
          );
        })}
      </div>

      <label
        className={`milestone-modal-label milestone-modal-label--compact ${compact ? "mt-2" : "mt-2"}`}
      >
        Default folder
        {required ? <span className="mandatory"> *</span> : null}
      </label>
      <MilestoneSingleOptionPicker
        layout="inline-field"
        value={selectedFolderName || ""}
        options={filteredFolderOptions}
        disabled={readOnly}
        showSearch
        addLabel="Select folder"
        changeLabel="Change folder"
        emptyPlaceholder="Select folder…"
        popoverTitle="Default folder"
        popoverSubtitle={`Choose from ${activeCategory} library`}
        searchPlaceholder="Search folders..."
        emptyMessage={`No folders in ${activeCategory} library yet.`}
        onChange={(folderName) => onFolderChange?.(folderName || "")}
      />
      {error ? <small className="text-danger d-block mt-1">{error}</small> : null}
    </div>
  );
};

export default MilestoneFolderSelect;
